module.exports = __webpack_public_path__ + "static/media/06.f5fa08e3.jpg";